import { NgModule } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

// PROVIDERS
import { AuthService } from './auth.service';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    globalHeaders: [
      { 'Accept': 'application/json' },
      { 'Content-Type': 'application/json' },
      { 'Cache-Control': 'no-cache' },
    ],
  }), http, options);
}

@NgModule({
  imports: [],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions],
    },
    AuthService,
  ],
})
export class AuthModule { }



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/auth/auth.module.ts